import React from "react"
import { Input } from "@/components/ui/input"
import type { InputProps as ShadcnInputProps } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export interface TextInputProps extends Omit<ShadcnInputProps, "variant"> {
  variant?: "outlined" | "filled" | "standard" | "minimal"
  label?: string
  helperText?: string
  error?: boolean
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ variant = "outlined", label, helperText, error, className, id, ...props }, ref) => {
    const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`
    const isMinimal = variant === "minimal"

    return (
      <div className="w-full space-y-2.5">
        {label && (
          <Label 
            htmlFor={inputId} 
            className={cn("mb-1", error && "text-destructive")}
            style={error ? { color: 'hsl(var(--destructive))' } : undefined}
          >
            {label}
          </Label>
        )}
        <Input
          ref={ref}
          id={inputId}
          variant={isMinimal ? "minimal" : "default"}
          className={cn(
            error && "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20",
            className
          )}
          {...props}
        />
        {helperText && (
          <p 
            className={cn("text-xs font-medium", error ? "text-destructive" : "text-muted-foreground")}
            style={error ? { color: 'hsl(var(--destructive))' } : undefined}
          >
            {helperText}
          </p>
        )}
      </div>
    )
  }
)
TextInput.displayName = "TextInput"

export default TextInput
